import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "modal-email-validation",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "modalEmailValidation",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "w-100 text-start fs-5 fw-600 m-0"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  type: "button",
  class: "btn btn-secondary btn-sm white-text-button",
  disabled: ""
}
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = {
  key: 0,
  class: "w-100 d-flex justify-content-between"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selectable = _resolveComponent("Selectable")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Validação por E-mail "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitModal && _ctx.exitModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, "Validação por E-mail"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "w-100 text-start fs-6 mb-2" }, "Selecione um e-mail *", -1)),
            (_openBlock(), _createBlock(_component_Selectable, {
              key: _ctx.emailSelectableKey,
              modelValue: _ctx.selectedEmail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEmail) = $event)),
              icon: "envelope",
              placeholder: "Selecione uma opção",
              options: _ctx.emailOptions
            }, null, 8, ["modelValue", "options"]))
          ]),
          (_ctx.emailWasSended)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_Input, {
                  modelValue: _ctx.code,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
                  label: "Digite abaixo o código enviado para seu e-mail *",
                  placeholder: "Digite o código",
                  icon: "lock-keyhole",
                  "error-log": _ctx.error
                }, null, 8, ["modelValue", "error-log"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.emailWasSended)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (!_ctx.canResendCode)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_11, " Reenviar código em " + _toDisplayString(_ctx.secondsToResendCode) + " segundos ", 1))
                  : _createCommentVNode("", true),
                (_ctx.canResendCode)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-outline-primary btn-sm",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendCodeToEmail && _ctx.sendCodeToEmail(...args)))
                    }, " Reenviar código "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  class: "button-without-border",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exitModal && _ctx.exitModal(...args)))
                }, " Escolher outro tipo de validação "),
                (!_ctx.emailWasSended)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass([
                'btn btn-sm',
                !_ctx.emailIsSelected
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]),
                      disabled: !_ctx.emailIsSelected,
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendCodeToEmail && _ctx.sendCodeToEmail(...args)))
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "me-2" }, "Enviar código", -1)),
                      _createVNode(_component_Icon, { name: "arrow-right" })
                    ], 10, _hoisted_14))
                  : _createCommentVNode("", true),
                (_ctx.emailWasSended)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: _normalizeClass(["btn btn-primary btn-sm", [
                'btn btn-sm',
                !_ctx.emailIsSelected || _ctx.code === ''
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]]),
                      disabled: !_ctx.emailIsSelected || _ctx.code === '',
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args)))
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "me-2" }, "Iniciar validação", -1)),
                      _createVNode(_component_Icon, { name: "arrow-right" })
                    ], 10, _hoisted_15))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (!_ctx.emailWasSended)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass([
                'btn mb-4',
                !_ctx.emailIsSelected
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]),
                      disabled: !_ctx.emailIsSelected,
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendCodeToEmail && _ctx.sendCodeToEmail(...args)))
                    }, _cache[13] || (_cache[13] = [
                      _createElementVNode("span", { class: "me-2" }, "Enviar código", -1)
                    ]), 10, _hoisted_17))
                  : _createCommentVNode("", true),
                (_ctx.emailWasSended)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: _normalizeClass([
                'btn mb-4',
                !_ctx.emailIsSelected || _ctx.code === ''
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]),
                      disabled: !_ctx.emailIsSelected || _ctx.code === '',
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args)))
                    }, _cache[14] || (_cache[14] = [
                      _createElementVNode("span", { class: "me-2" }, "Iniciar validação", -1)
                    ]), 10, _hoisted_18))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  class: "button-without-border",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.exitModal && _ctx.exitModal(...args)))
                }, " Escolher outro tipo de validação ")
              ]))
        ])
      ])
    ])
  ]))
}